import { render, staticRenderFns } from "./UsdtFee.vue?vue&type=template&id=7e5d4a2c&scoped=true"
import script from "./UsdtFee.vue?vue&type=script&lang=js"
export * from "./UsdtFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5d4a2c",
  null
  
)

export default component.exports